import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity/activity.uha';

const translations = generateTranslations(namespace, {
  loading: {
    nb: 'Laster aktivitet...',
    en: 'Loading activity...',
  },
  pageSubtitle: {
    nb: 'Fyll ut behov for plasser og fyll ut bestillingen før du deler med praksisstedene.',
    en: 'Register how many places you need, fill in the order and share it with the practice places.',
  },
  subtitle: {
    nb: 'Oppgi tidsperiode for aktiviteten og angi antall studenter det antas det er behov for.',
    en: 'Set the time period for the activity and plot in the number of students you need.',
  },
  dateFrom: {
    nb: 'Oppstart',
    en: 'Start date',
  },
  dateTo: {
    nb: 'Avslutning',
    en: 'End date',
  },
  estimatedPlacesNeed: {
    nb: 'Estimert behov',
    en: 'Places needed',
  },
  capacity: {
    nb: 'Kapasitet',
    en: 'Capacity',
  },
  capacityPlaceholder: {
    nb: 'Ikke delt',
    en: 'Not provided',
  },
  realNeed: {
    nb: 'Reelt behov',
    en: 'Real need',
  },
  realNeedTooltip: {
    nb: 'Antall studenter i denne praksisklassen',
    en: 'Number of students in this practice class',
  },
  create: {
    nb: 'Opprett aktivitet',
    en: 'Create Activity',
  },
  save: {
    nb: 'Lagre',
    en: 'Save',
  },
  share: {
    nb: 'Del med praksissted',
    en: 'Share with practice places',
  },
  saveAndShare: {
    nb: 'Lagre og del',
    en: 'Save and share',
  },
  back: {
    nb: 'Til kalenderen',
    en: 'To the calendar',
  },
  delete: {
    nb: 'Slett hele aktivitet',
    en: 'Delete entire activity',
  },
  bestiller: {
    nb: 'Bestiller',
    en: 'Place of order',
  },
  saveSuccess: {
    nb: 'Praksisaktivitet lagt til',
    en: 'Save successful',
  },
  changeSuccess: {
    nb: 'Praksisaktivitet endret',
    en: 'Save successful',
  },
  deleteSuccess: {
    nb: 'Sletting vellykket',
    en: 'Delete successful',
  },
  deleteConfirmationDialogTitle: {
    nb: 'Slett praksisaktivitet',
    en: 'Delete activity',
  },
  deleteConfirmationDialogContents: {
    nb: 'Er du sikker på at du vil slette denne praksisaktiviteten?',
    en: 'Are you sure you want to delete this activity?',
  },
  deleteSharedActivityConfirmationDialogContents: {
    nb:
      'Denne aktiviteten har allerede blitt delt med flere praksissteder. ' +
      'Sletting av aktiviteten vil føre til at du mister kapasiteten som har blitt meldt inn. ' +
      'Er du sikker på at vil slette denne aktiviteten?',
    en:
      'This activity has already been shared with multiple workplaces. ' +
      'Deleting an activity will result in losing the existing capacity orders. ' +
      'Are you sure you want to delete this activity?',
  },
  deleteSharedActivityWithOnskerConfirmationDialogContents: {
    nb:
      'Denne aktiviteten har blitt delt med flere praksissteder og har åpen ønskeliste. ' +
      'Sletting av aktiviteten vil også føre til at innmeldt kapasitet og eventuelle ønsker fra studentene blir fjernet. ' +
      'Er du sikker på at vil slette denne aktiviteten?',
    en:
      'This activity has already been shared with multiple workplaces and it has an open wish list. ' +
      'Deleting this activity will result in losing the existing capacity orders and the wishes made by the students. ' +
      'Are you sure you want to delete this activity?',
  },
  changePeriodConfirmationDialogTitle: {
    nb: 'Endre tidsperioden for praksisaktiviteten?',
    en: 'Changing period for the activity?',
  },
  changePeriodConfirmationDialogContents: {
    nb:
      'Du er i ferd med å endre perioden på en aktivitet som allerede har blitt delt med flere praksissteder. ' +
      'Endring av start- eller slutt-dato for aktiviteten vil føre til at du mister den innmeldte kapasiteten fra praksisstedene. ' +
      'Er du sikker på at vil endre perioden for denne aktiviteten?',
    en:
      'You are about to change the period for an activity that has already been shared with with multiple workplaces. ' +
      'Changing start or end date for the activity will result in losing existing ordered capacity from the workplaces. ' +
      'Are you certain about changing the period for this activity?',
  },
  praksisaktivitet: {
    nb: 'Praksisaktivitet',
    en: 'Practice activity',
  },
  praksisperiode: {
    nb: 'Praksisperiode',
    en: 'Practice period',
  },
  steder: {
    nb: 'Steder',
    en: 'Places',
  },
  roller: {
    nb: 'Roller',
    en: 'Roles',
  },
  registrering: {
    nb: 'Registrering',
    en: 'Registration',
  },
  vurdering: {
    nb: 'Vurdering',
    en: 'Assessment',
  },
  fordeling: {
    nb: 'Fordeling',
    en: 'Assignments',
  },
  oppsummering: {
    nb: 'Oppsummering',
    en: 'Summary',
  },
  detaljer: {
    nb: 'Detaljer',
    en: 'Details',
  },
  bestilling: {
    nb: 'Bestilling',
    en: 'Order',
  },
  aktivitetsbestiller: {
    nb: 'Bestiller',
    en: 'Orderer',
  },
  aktivitetsstatus: {
    nb: 'Status',
    en: 'Status',
  },
  aktivitetspraksistype: {
    nb: 'Praksistype',
    en: 'Practice type',
  },
  aktivitetsemnenavn: {
    nb: 'Emnenavn',
    en: 'Subject name',
  },
  aktivitetsemnebeskrivelse: {
    nb: 'Emnebeskrivelse',
    en: 'Subject description',
  },
  aktivitetsklasse: {
    nb: 'Praksisklasse',
    en: 'Practice Class',
  },
  onskeliste: {
    nb: 'Ønskeliste',
    en: 'Wish list',
  },
  onskelistebeskrivelse: {
    nb: 'Velg når aktiviteten skal åpnes for studentenes ønsker',
    en: "Choose when the activity is to be opened to students' wishes",
  },
  onskelisteAapenLES: {
    nb: 'Ønskelisten er for øyeblikket åpen.',
    en: 'The wish list is open at the moment.',
  },
  onskelisteLukketLES: {
    nb: 'Ønskelisten er for øyeblikket lukket.',
    en: 'The wish list is closed at the moment.',
  },
  onskelisteSvarfristLES: {
    nb: 'Svarfristen for ønskelisten er satt til:',
    en: 'The deadline for the wish list is set to:',
  },
  onskelisteMaksgrenseLES: {
    nb: 'Maksgrensen for antall ønsker en student kan gjøre er:',
    en: 'The max. no. wishes a student may put is set to:',
  },
  onskelisteTilDato: {
    nb: 'Åpne opp for studentønsker med svarfrist:',
    en: 'Open up for student requests with deadline:',
  },
  onskelisteEndreDato: {
    nb: 'Endre svarfrist for ønskelisten:',
    en: 'Change wish list deadline:',
  },
  dontOfferOnskeliste: {
    nb: 'Ikke tilby ønskelister for denne aktiviteten',
    en: 'Do not offer wish lists for this activity',
  },
  openOnskeliste: {
    nb: 'Åpne ønskeliste',
    en: 'Open wish list',
  },
  closeOnskeliste: {
    nb: 'Avslutt ønskeliste',
    en: 'Terminate wish list',
  },
  onskelisteTidspunktEndret: {
    nb: 'Tidspunkt for ønskelisten er endret',
    en: 'The new date is saved',
  },
  onskelisteAktivert: {
    nb: 'Ønskelisten er aktivert',
    en: 'Wish list activated',
  },
  onskelisteDeaktivert: {
    nb: 'Ønskelisten er deaktivert',
    en: 'Wish list deactivated',
  },
  onskelisteAapnet: {
    nb: 'Ønskelisten er åpnet',
    en: 'Wish list opened',
  },
  onskelisteAvsluttet: {
    nb: 'Ønskelisten er avsluttet',
    en: 'Wish list closed',
  },
  aktivitetskrav: {
    nb: 'Aktivitetskrav',
    en: 'Activity requirements',
  },
  velgAktivitetskrav: {
    nb: 'Velg aktivitetskrav',
    en: 'Choose activity requirements',
  },
  manglerBehov: {
    nb: 'Legg inn bestillinger',
    en: 'Add your requests',
  },
  deltMedNoenPraksissteder: {
    nb: 'Bestillingen er ikke delt med alle praksissteder',
    en: 'Order has not been shared with all practice places',
  },
  venterPaaOnskeliste: {
    nb: 'Ønskelisten er åpen for studentene til og med ',
    en: 'The wish list is available for students until and including ',
  },
  avsluttetOnskeliste: {
    nb: 'Ønskelisteperioden er avsluttet, klar til å fordele studenter',
    en: 'The wish list is closed, students can be assigned to practice places',
  },
  antallOnskerLabel: {
    nb: 'Du kan endre maksgrensen for antall ønsker en student kan gjøre i dette feltet:',
    en: 'Adjust the number of wishes a student can make in the following input field:',
  },
  antallOnsker: {
    nb: 'Maksimalt antall ønsker:',
    en: 'Max no. wishes:',
  },
  bekreftAntallforandring: {
    nb: 'Bekreft endring i maks. antall ønsker',
    en: 'Confirm change in max. no. wishes',
  },
  endretAntallOnsker: {
    nb: 'Maks. antall ønsker er endret.',
    en: 'Max no. wishes has been updated.',
  },
  praksisklasseChanged: {
    nb:
      'Advarsel: Endring av navnet på en praksisklasse endrer dette for alle ' +
      'praksisaktiviteter under denne praksisklassen, gjennom hele studieåret.\n' +
      'Navnet vil også være synlig for relevante praksisstedbrukere.',
    en:
      'Warning: Editing the name of a practice class will change it for all ' +
      'practice activities applied to this practice class for the entire year.\n' +
      'The name will also be visible to affiliated practice place users.',
  },
  documentTitle: {
    nb: 'Aktivitet',
    en: 'Activity',
  },
  copyActivityModalTitle: {
    nb: 'Kopier praksisaktivitet',
    en: 'Copy practice activity',
  },
  copyActivityModalTitleShort: {
    nb: 'Kopier',
    en: 'Copy',
  },
  copyActivityModalSubtitle: {
    nb: 'For å kopiere praksisaktiviteten over til en ny periode/klasse, fyll inn informasjonen under. Hva som skal kopieres over til den nye aktiviteten bestemmes av det som er huket av nedenfor.',
    en: 'To copy the practice activity to a new practice period/class, fill inn the required information below. What should be copied into the new activity is set by the checkboxes.',
  },
  copyActivityModalSubmit: {
    nb: 'Lag kopi av aktiviteten',
    en: 'Generate copy of the activity',
  },
  copyActivityModalCheckboxesLabel: {
    nb: 'Huk av for hvilke deler av praksisaktiviteten som skal kopieres.',
    en: 'Add check marks for which parts of the practice activity to copy.',
  },
  copyActivityModalAktivitetskrav: {
    nb: 'Aktivitetskrav',
    en: 'Activity requirement',
  },
  copyActivityModalFritekst: {
    nb: 'Beskrivelse (fritekst)',
    en: 'Description (optional info text)',
  },
  copyActivityModalBestillingerBesvarelser: {
    nb: 'Bestillinger og besvarelser',
    en: 'Orders and capacities',
  },
  copyActivityModalFordeling: {
    nb: 'Fordeling',
    en: 'Assignment',
  },
  copyActivityModalPeriodeKlasseHeader: {
    nb: 'Periode og praksisklasse',
    en: 'Period and practice class',
  },
  copyActivityModalPeriodeKlasseHeaderSubtitle: {
    nb: 'En aktivitetskopi kan ikke overlappe perioden og klassen til en eksisterende aktivitet. Kopiens periode må være innenfor valgt undervisningsperiode.',
    en: 'A copy of an activity cannot overlap with the period and class of an existing activity. A new period cannot exceed the selected term.',
  },
  copyActivityModalUndervisningsperiode: {
    nb: 'Undervisningsperiode',
    en: 'Study period',
  },
  copyActivityModalPartsHeader: {
    nb: 'Velg hvilke deler av praksisaktiviteten som skal kopieres',
    en: 'Choose which parts of the practice activity to copy',
  },
  copyActivityModalPartsHeaderSubtitle: {
    nb: 'For at man skal kunne kopiere fordeling eller roller, må bestillinger og besvarelser være huket av. Om fordeling er huket av, men ikke roller, kopieres kun studentenes plassering, og ikke undervisere/veiledere. NB: Studenter som ikke lenger er registrert til valgt praksisklasse, vil ignoreres ved kopiering av fordeling.',
    en: 'To copy assignment or roles, orders and capacities must be checked. If assignment is checked, but roles is not, only the placement of the students will be copied, and not tutors/supervisors. Note: Students that are no longer registered to the chosen practice class, will be ignored when copying assignment.',
  },
  copyActivityModalOverlappingPeriod: {
    nb: 'Valgt periode og klasse overlapper med eksisterende aktivitet.',
    en: 'The selected period and class overlaps with an existing activity.',
  },
  copyActivityModalChangedKlasse: {
    nb: 'Når praksisklassen eller undervisningsperioden blir endret, kan ikke fordelingen kopieres.',
    en: 'When the practice class or study period is changed, the assignment cannot be copied.',
  },
  copyActivityModalSuccessMsg: {
    nb: 'Praksisaktiviteten ble kopiert.',
    en: 'The practice activity was copied.',
  },
  cancel: {
    nb: 'Avbryt',
    en: 'Cancel',
  },
  endretAv: {
    nb: 'Sist endret { endretTidspunkt } av { fornavn } { etternavn }',
    en: 'Last edit at { endretTidspunkt } by { fornavn } { etternavn }',
  },
  fritekstTitle: {
    nb: 'Om praksisaktiviteten',
    en: 'About the practice activity',
  },
  fritekstSubtitle: {
    nb: 'I fritekstfeltet kan man fylle inn informasjon som skal deles med både praksisstedbrukere og studenter. Feltet er valgfritt å fylle inn.',
    en: 'In the text area below, you may fill in information that will be shared with both practice place users and students. This is optional.',
  },
  fritekstPlaceholder: {
    nb: 'Fyll inn valgfri informasjon som skal deles med praksissteder og studenter. F.eks.\n\nTil studenter:\nInformasjon om praksisperioden finner dere her (Lenke)\n\nTil veiledere:\nInformasjon om veiledning og vurdering finner dere her (Lenke)\nInformasjon om lønn og utbetaling finner dere her (Lenke)\n\nTil praksisstedkoordinatorer:\nUtfyllende informasjon om bestillingen finner du her (Lenke). Spørsmål til bestillingen kan rettes til (lenke til personkort eller felles epostadresse).',
    en: 'Fill in optional information that is to be shared with practice places and students. Example:\n\nFor students:\nInformation regarding your practice period can be found here (Link).\n\nFor supervisors:\nInformation regarding supervision and assessment can be found here (Link).\nInformation regarding salary and payment can be found here (Link).\n\nFor coordinators at practice places:\nInformation regarding the order can be found here (Link). Questions regarding the order may be adressed to (Link to person or email).',
  },
  sistPublisertTilFS: {
    nb: 'Sist publisert til FS:',
    en: 'Last written to FS:',
  },
  ikkePublisert: {
    nb: 'Ikke publisert',
    en: 'Not published',
  },
  fsStatus: {
    nb: 'FS-status: { postfix }',
    en: 'FS status: { postfix }',
  },
  fsStatusIngenFeil: {
    nb: 'Ingen feil',
    en: 'No errors',
  },
  fsStatusFeilVedPublisering: {
    nb: 'Feil ved publisering',
    en: 'Error when publishing',
  },
  fsStatusUkjentFeil: {
    nb: 'Ukjent feil',
    en: 'Unknown error',
  },
});

export default translations;
